import * as React from 'react';


export default class Nfreassign extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 12 12" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g fill="none" fillRule="evenodd" stroke="#FFF" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1.508 3.643h8.7l-1.296-2.09M8.866 5.525l1.314-1.84"/>
            <g>
                <path d="M10.492 8.643h-8.7l1.296-2.09M3.147 10.249l-1.36-1.594"/>
            </g>
        </g>
      </svg>
    )
  }
}
